import Currency from './Currency';
import Phone from './Phone';
import Number from './Number';

export default {
  currency: Currency,
  number: Number,
  phone: Phone,
};
